module.exports = __webpack_public_path__ + "img/eservices-gov-ss.93c2b9d4.svg";